import React, { useContext, useEffect, useMemo, useState } from 'react';
import { getFluentTheme } from './FluentThemes';
import { initializeIcons, ThemeProvider } from '@fluentui/react';
import { ThemeContextType } from '../Models/Constants/Types';
import { ThemeStorageKey } from '../Models/Constants/Constants';
import { Theme } from '../Models/Constants/Enums';

const ThemeContext = React.createContext<ThemeContextType>({
    selectedTheme: Theme.Kraken,
    setSelectedTheme: () => {}
});
export const useThemeContext = () => useContext(ThemeContext);

// Required to load fluent UI icons
initializeIcons();

export const ThemeProviderWrapper: React.FC<{}> = ({ children }) => {
    const [theme, setTheme] = useState<Theme>(
        (localStorage.getItem(ThemeStorageKey) as Theme) || Theme.Kraken as Theme
    );
    const fluentTheme = useMemo(() => getFluentTheme(theme), [theme]);

    useEffect(() => {
        localStorage.setItem(ThemeStorageKey, theme);
    }, [theme]);

    return (
        <ThemeContext.Provider
            value={{ selectedTheme: theme, setSelectedTheme: setTheme }}
        >
            <ThemeProvider theme={fluentTheme} applyTo={'body'}>
                <div
                    cardboard-app-data-theme={theme}
                    cardboard-data-theme={theme}
                >
                    {children}
                </div>
            </ThemeProvider>
        </ThemeContext.Provider>
    );
};
